import axios from "axios";

/**
 * Send a note to the notes system
 * @param {Object} customer - Customer object with firstname, lastname, email, phone
 * @param {String} notePrefix - Prefix for the note (e.g., 'appointment created', 'appointment updated', 'appointment cancelled')
 * @param {String} userNote - User's note text from the form (optional)
 * @param {Object} appointmentData - Appointment data including id, service_id, etc.
 * @returns {Promise}
 */
export async function sendAppointmentNote(customer, notePrefix, userNote = '', appointmentData = {}) {
  const apiURL = import.meta.env.VITE_API_URL;

  // Get page title for salon_id
  const getPageTitle = () => {
    let indi = document.title.search("([0-9]|[1-9])");
    return document.title
      .slice(indi + 2)
      .replaceAll("_", " ")
      .trim();
  };

  // Combine the prefix with the user's note
  const fullNote = userNote ? `${notePrefix}.\n${userNote}` : `${notePrefix}.`;

  const notePayload = {
    customer: {
      firstname: customer.firstname,
      lastname: customer.lastname,
      email: customer.email,
      phone: customer.phone,
    },
    salon_id: getPageTitle(),
    salon_client_id: customer.id || 0,
    salon_appointment_id: appointmentData.id || 0,
    salon_appointment_service_id: appointmentData.service_id || [],
    client_note: fullNote,
  };

  try {
    const response = await axios.post(apiURL + "notes", notePayload);
    return response;
  } catch (error) {
    console.error('Error sending note:', error);
    throw error;
  }
}
